// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary_blue": "#1791dd",
	"default_hover": "#5cb1e7",
	"default_background": "#eef7fd",
	"high_emphasis_grey": "#212121",
	"medium_emphasis_grey": "#666",
	"disabled_grey": "#a8a8a8",
	"border_grey": "#ccc",
	"input_disabled": "#e9e9e9",
	"input_active": "#e1e1e1",
	"alert_red": "#ff3b30",
	"background_red": "#ffefee",
	"caution_orange": "#ff952a",
	"caution_background": "#fff7ee",
	"success_green": "#34c759",
	"toast_green": "#1f7a3c",
	"toast_background": "#eaf9e0",
	"white": "#fff",
	"rippleColor": "#bfe5fe"
};
export default ___CSS_LOADER_EXPORT___;
